import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import api from '../../api/api'
import { useSnackbar } from '../../helpers/hooks/useSnackbar'

import { getPackageSessions, removePackageSessions } from './hooks/useOfflineMode'
import { removePackagesSession } from './hooks/useSynchroniseOfflinePackages'

const OfflinePackages = () => {
  const { t } = useTranslation(['package-room'])
  const [isSyncing, setIsSyncing] = useState(false)
  const { displaySnackbar } = useSnackbar()

  const handleCopyToClipboard = async () => {
    const packageData = JSON.stringify(getPackageSessions(), null, 2)
    try {
      await navigator.clipboard.writeText(packageData)
      displaySnackbar(t('package-room:offlinePackages.copiedToClipboard'))
    } catch {
      displaySnackbar(t('package-room:offlinePackages.errorCopyFailed'), true)
    }
  }

  const handleForcePackagesSync = async () => {
    const packageSessions = getPackageSessions()
    setIsSyncing(true)

    try {
      for (const packageSession of packageSessions) {
        const { id, packages, startTime, endTime } = packageSession
        await api.syncOfflinePackageSession({ packages, startTime, endTime })
        removePackagesSession(id)
      }
    } catch {
      displaySnackbar(t('package-room:offlinePackages.errorSyncFailed'), true)
    } finally {
      setIsSyncing(false)
    }
  }

  const handleRemoveCachedPackages = async () => {
    removePackageSessions()
    displaySnackbar(t('package-room:offlinePackages.packagesRemoved'))
  }

  return (
    <div className="offline-packages">
      <h1 className="offline-packages__title">{t('package-room:offlinePackages.title')}</h1>
      <div>
        <button onClick={handleCopyToClipboard} className="offline-packages__copy-button">
          {t('package-room:offlinePackages.copyToClipboard')}
        </button>
        <button
          disabled={isSyncing}
          onClick={handleForcePackagesSync}
          className="offline-packages__sync-button"
        >
          {isSyncing
            ? t('package-room:offlinePackages.syncing')
            : t('package-room:offlinePackages.forcePackagesSync')}
        </button>
        <button onClick={handleRemoveCachedPackages} className="offline-packages__remove-button">
          {t('package-room:offlinePackages.removeCachedPackages')}
        </button>
      </div>
      <pre className="offline-packages__data">{JSON.stringify(getPackageSessions(), null, 2)}</pre>
    </div>
  )
}

export default OfflinePackages
